<template>
  <v-container fluid grid-list-sm>
    <v-card v-if="mode === 'list'">
      <v-toolbar :dense="true" >
        <v-toolbar-title class="body-2"> <v-icon>mdi-redo-variant</v-icon> RI Recoveries </v-toolbar-title>
        <v-spacer />
        <span class="body-2">Claim No: {{ this.commonInfo.clmNo }}</span>
      </v-toolbar>
      <v-data-table :headers="paymentColumns" :items="riRecoveries" class="elevation-1" >
        <template v-slot:item="row"
          ><tr>
            <td>{{ row.item.clmtNo }}</td>
            <td>{{ row.item.clmItem }}</td>
            <td>{{ row.item.clmResCat }}</td>
            <!-- <td>{{ row.item.orgTranType }}</td> -->
            <td>{{ row.item.orgDocNo }}</td>
            <td>{{ row.item.riType }}</td>
            <td>{{ row.item.acctNoSfx }}</td>
            <td>{{ row.item.riCo }}</td>
            <td>{{ row.item.curr }}</td>
            <td class="text-right">{{ row.item.rcvyAmt }}</td>
            <!-- <td class="text-right">{{ row.item.rcvyAmtLoc }}</td> -->
            <td class="text-right">{{ row.item.rcvredAmtLoc }}</td>
            <td>{{ row.item.rcvyDocNo }}</td>
            <td>{{ formatDisplayDate(row.item.tranDate) }}</td>
            <td>{{ row.item.acctMth }} / {{ row.item.acctYr }}</td>
            <!-- <td>{{ row.item.acctYr }}</td> -->
            <!-- <td>{{ formatDateTime2(row.item.createdDate) }}</td> -->
            <td>{{ formatDisplayDateTime4(row.item.createdDate) }}</td>
            <td>{{ row.item.usrRefId }}</td>
          </tr></template
        >
      </v-data-table>
      <v-card-actions>
        <v-spacer />
        <v-btn color="red darken-1" text @click.native="doClose">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import { formatDisplayDate, formatDisplayDateTime4 } from '@/utils/date'
import MessageMixin from '@/mixins/message'
import * as TableConst from '@/mixins/table'
export default {
  props: {},
  data() {
    return {
      loading: false,
      mode: 'list',
      paymentColumns: [
        { text: 'Clmt No', align: 'left', value: 'clmtNo' },
        { text: 'Clm Item', align: 'left', value: 'clmItem' },
        { text: 'Res Catg', align: 'left', value: 'clmResCat' },
        // { text: 'Type', align: 'left', value: 'orgTranType' },
        { text: 'Orig Doc No.', align: 'left', value: 'orgDocNo' },
        { text: 'RI Type', align: 'left', value: 'riType' },
        { text: 'RI Co', align: 'left', value: 'riCo' },
        { text: 'Sfx', align: 'left', value: 'acctNoSfx' },
        { text: 'Rcvy Curr', align: 'left', value: 'curr' },
        { text: 'Rcvy Amt', align: 'right', value: 'rcvyAmt' },
        // { text: 'Rcvy Amt Loc', align: 'right', value: 'rcvyAmtLoc' },
        { text: 'Rcvred Amt', align: 'right', value: 'rcvredAmtLoc' },
        { text: 'Rcvy DocNo', align: 'left', value: 'rcvyDocNo' },
        { text: 'Tran Date', align: 'left', value: 'tranDate' },
        // { text: 'Acct Month', align: 'left', value: 'acctMth' },
        // { text: 'Acct Year', align: 'left', value: 'acctYr' },
        { text: 'Acct Period', align: 'left', value: 'acctMth' },
        { text: 'Entry Date', align: 'left', value: 'createdDate' },
        { text: 'User ID', align: 'left', value: 'createdBy' }
      ]
    }
  },
  computed: {
    commonInfo() {
      return this.$store.state.claims.claimDetail.commonInfo
    },
    riRecoveries() {
      return this.commonInfo.clmRiRcvys
    }
  },
  methods: {
    formatBoolean(value) {
      if (value) {
        return 'Yes'
      }
      return 'No'
    },
    doClose() {
      this.$emit('close')
    },
    formatDisplayDate(value) {
      if (value) {
        return formatDisplayDate(value)
      } else {
        return ''
      }
    },
    formatDisplayDateTime4(dateTime) {
      if (dateTime) {
        return formatDisplayDateTime4(dateTime)
      } else {
        return ''
      }
    }
  },
  mixins: [MessageMixin, TableConst.default]
}
</script>

<style>
</style>
